import React, { useState } from 'react'
import './fileviewer.css';
import ToggleContainer from '../ToggleContainer/togglecontainer';

const SHOW_ATTR = new Set(['width', 'height', 'size', 'type', 'origin']);
/** 
 * FileViewer component displays the details of a file, including its name, size, type, and dimensions.
 * It also shows a preview image of the file if available.
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.background - The URL of the background image to display.
 * @param {Object} props.content - The content object containing file details.
 * @returns {JSX.Element} The rendered FileViewer component. 
 */
const FileViewer = ({ background, content }) => {
    const [collapsed, setCollapsed] = useState(true);

    function handleCollapseClick( collapse ){
        setCollapsed(collapse);
    }

    return (
    <div className='fileviewer-container'>
        <small >Successfully loaded file:</small>
        <h3 className='preview-header-text'>{content.fileName}</h3>
        <div id='preview-container'>
            <ToggleContainer toggled={false}>
                <div className='preview-image-container'>  
                <img src={background} className={'preview-image'}></img>
                </div>
                <table className='prop-table'>
                    <tbody>
                        { content && Object.entries(content).map(( [k,v], i )=>{
                            if (!SHOW_ATTR.has(k) || k==='content' || k==='fileName') return null;    
                            return (
                                <tr key={i}>
                                    <td className='object-props'>{k}</td>
                                    <td className='object-props'>{v}</td>
                                </tr>
                            );
                        })}
                </tbody>
                </table>
            </ToggleContainer>
            {/* { !collapsed && ( <>
                <div className='preview-image-container'>  
                <img src={background} className={'preview-image'}></img>
                </div>
                <table className='prop-table'>
                    <tbody>
                        { content && Object.entries(content).map(( [k,v], i )=>{
                            if (!SHOW_ATTR.has(k) || k==='content' || k==='fileName') return null;    
                            return (
                                <tr key={i}>
                                    <td className='object-props'>{k}</td>
                                    <td className='object-props'>{v}</td>
                                </tr>
                            );
                        })}
                </tbody>
                </table>
            </>)} */}
            {/* <ToggleSwitch onToggle={handleCollapseClick}/> */}
        </div>
    </div>
  )
}

export default FileViewer